
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qzroyvphrccqjuyhxyjs.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6cm95dnBocmNjcWp1eWh4eWpzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg5NTIyMjEsImV4cCI6MjA1NDUyODIyMX0.v5dlkzVQgPyyH4YHgbVSLJ49cUG0gh6Ot4-aHbZDJds';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  // Add connection resilience
  global: {
    headers: {
      'X-Client-Info': 'livetrack-web@1.0.0',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Connection health monitoring
let connectionHealthStatus = 'unknown';
let lastHealthCheck = 0;

export const checkSupabaseHealth = async (): Promise<boolean> => {
  try {
    const startTime = Date.now();
    const { error } = await supabase.auth.getSession();
    const latency = Date.now() - startTime;
    
    if (error && (error.message?.includes('network') || error.message?.includes('timeout'))) {
      connectionHealthStatus = 'unhealthy';
      return false;
    }
    
    connectionHealthStatus = latency < 5000 ? 'healthy' : 'slow';
    lastHealthCheck = Date.now();
    return true;
  } catch (error) {
    connectionHealthStatus = 'unhealthy';
    return false;
  }
};

export const getConnectionStatus = () => ({
  status: connectionHealthStatus,
  lastCheck: lastHealthCheck
});

console.log('Supabase client initialized with enhanced reliability');
